import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../App/redux/store';
import { APIStatus } from '../../services/axiosEnums';
import useUsers from '../users/useUsers';
import { getFoldersState } from './foldersSlice';
import { fetchFoldersThunk } from './services/foldersThunks';

interface IUseFoldersProps {
  folderId?: string;
  userId?: string;
}
function useFolders({ folderId }: IUseFoldersProps) {
  const [selectedFolder, setSelectedFolder] = useState<IFolder | null>(null);
  const { folders, deleteModal } = useAppSelector(getFoldersState);
  const { users } = useUsers();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isEmpty(folders.result) && users) {
      dispatch(fetchFoldersThunk());
    }
  }, [users]);

  useEffect(() => {
    if (folders.result && folderId) {
      let folderTemp = null;

      if (folderId) {
        folderTemp = folders.result?.find((f) => f.id === parseInt(folderId));
      }

      setSelectedFolder(folderTemp ?? null);
    }
  }, [folders.result, folderId]);

  return {
    folders,
    selectedFolder,
    deleteModal,
    foldersStatusPending: folders.apiStatus === APIStatus.PENDING,
  };
}

export default useFolders;
